import Link from 'next/link';
import classNames from 'classnames';
import Image from 'next/image';
import i18n from '@/settings/i18n';
import { getEdgeUrl } from '@/lib/getEdgeUrl';

const t = i18n.init('shared');

const GamingCard = ({ className }: { className?: string }) => (
  <Link
    href="/collections/gaming/05m6w134l0u2"
    className={classNames(
      'relative -mb-px -mr-px flex h-full min-h-[265px] cursor-pointer flex-col border border-gray-500 bg-teal-500 text-left text-xs',
      className,
    )}
  >
    <div className="relative z-10 flex flex-col items-center p-3 text-center sm:px-4 sm:py-6">
      <div className="text-lg font-bold leading-tight md:text-xl">
        {t`Play more. Pay less.`}
      </div>
      <div className="mt-2 text-sm leading-snug">
        {t`Score premium refurbished consoles for up to 70% vs new.`}
      </div>
      <button
        type="button"
        className="mt-4 rounded-full bg-gray-700 px-4 py-2 text-xs font-extrabold text-white"
      >
        {t`Shop New`}
      </button>
    </div>
    <div className="absolute bottom-0 z-0 w-full opacity-25 xxs:opacity-100">
      <Image
        src={getEdgeUrl('images/hot-deals/shop-gaming.png')}
        className="h-auto w-full object-cover"
        alt="bundle"
        width={500}
        height={300}
        sizes="140px"
        loading="lazy"
      />
    </div>
  </Link>
);

export default GamingCard;
